import { FileUploadProgressDTO } from "@js/DTO/FileUploadProgressDTO.cs.d";
import { DealFileAttachmentHelper } from "@js/helpers/DealFileAttachmentHelper";
import { AuthService } from "@js/services/AuthService";
import { DealLenderService } from "@js/services/Deal/DealLenderService";
import { SharedHeadsOfTermsService } from "@js/services/Deal/SharedHeadsOfTermsService";
import { FeedBackService } from "@js/services/FeedBackService";
import { RoleService } from "@js/services/RoleService";
import { SelectListService } from "@js/services/SelectListService";
import { UserService } from "@js/services/UserService";
import {
  ApplicationUser,
  ApplicationUserCrudClient,
  BridgingSubmitOfferRequest,
  CaseLenderStateEnum,
  DealFileAttachment,
  DealFileAttachmentClient,
  DealLender,
  DealLenderClient,
  DealLenderMessage,
  DealLenderMessageClient,
  DevelopmentFinanceDeal,
  DevelopmentFinanceDealClient,
  FeedBack,
  FeedBackClient,
  FileAttachment,
  InterestRateTypeEnum,
  MessageRoleEnum,
  ModuleEnum,
  ProductClient,
  UserClient,
} from "@src/apis/ModularClient";
import ProductHelper from "@js/helpers/ProductHelper";
import { BaseHeadsOfTermsController } from "@js/controllers/BaseHeadsOfTermsController";
import { IndexService } from "@js/services/IndexService";
import { ODataHelper } from "@js/helpers/ODataHelper";

export class DevFinanceHeadsOfTermsController extends BaseHeadsOfTermsController {
  static $inject = [
    "$routeParams",
    "$rootScope",
    "$location",
    "RoleService",
    "DealLenderMessageClient",
    "DealFileAttachmentHelper",
    "DealFileAttachmentClient",
    "$window",
    "DevelopmentFinanceDealClient",
    "DealLenderClient",
    "SelectListService",
    "FeedBackService",
    "FeedBackClient",
    "UserClient",
    "UserService",
    "ApplicationUserCrudClient",
    "IndexService",
    "AuthService",
    "SharedHeadsOfTermsService",
    "ProductClient",
    "DealLenderService",
    "ODataHelper",
    "$timeout",
  ];

  dealLenders: DealLender[];
  showInformationMessage: boolean = false;
  messageContent: string;

  showDirection: boolean = false;

  toggleHoTDetailSection: boolean = false;
  toggleRejectSection: boolean = false;
  toggleWithdrawSection: boolean = false;

  // show different sections to Lender based on which button clicked on Case Dashboard
  showFeedbackSectionLender: boolean = false;
  showHoTDetailSectionLender: boolean = false;
  showRejectSectionLender: boolean = false;
  showWithdrawSectionLender: boolean = false;

  showTsAndCsModal: boolean = false;
  showTsAndCsForm: boolean = false;
  sendingMessage: boolean = false;
  goToUserDashboard: boolean = false;

  currentDeal: DevelopmentFinanceDeal;
  InterestRateTypeOptions = [];

  lenderTask: string = "";

  isRejectClicked: boolean = false;
  isWithdrawClicked: boolean = false;
  isConfirmClicked: boolean = false;
  isSubmitClicked: boolean = false;

  //Lender Message
  newChatMessage: string = "";
  showFullMessageId: number;

  //files
  fileUpload: DealFileAttachment[];
  uploadingFiles: FileUploadProgressDTO[] = [];
  openModal: boolean = false;
  module = ModuleEnum.DIP;

  showFullLenderMessage = false;
  showFullBorrowerMessage = false;
  showAutofill: boolean = false;

  //Lender/Broker feedback properties
  showLenderFeedBackModal: boolean = false;
  showBrokerFeedBackModal: boolean = false;
  prevPath: string;
  brokerName: string;
  brokerOrganisationName: string;
  lendingForm: ng.IFormController;

  //Deleteing a chat message
  selectedDealLenderMessageDto: DealLenderMessage;
  showdeleteChatMessageModal: boolean = false;
  showConfirmDeleteButton: boolean = false;

  grossLoanCalcVal: number = 0;
  builLoanCalcVal: number = 0;
  landLoanCalcVal: number = 0;
  isDevFinance: boolean = true;

  productTypeText: string = null;
  noLenderOrMoreLenderError: boolean = false;

  constructor(
    $routeParams: ng.route.IRouteParamsService,
    private $rootScope: ng.IRootScopeService,
    private $location: ng.ILocationService,
    roleService: RoleService,
    dealLenderMessageClient: DealLenderMessageClient,
    private dealFileAttachmentService: DealFileAttachmentHelper,
    private dealFileAttachmentClient: DealFileAttachmentClient,
    private $window: ng.IWindowService,
    private developmentFinanceDealClient: DevelopmentFinanceDealClient,
    private dealLenderClient: DealLenderClient,
    private selectListService: SelectListService,
    private feedBackService: FeedBackService,
    private feedBackClient: FeedBackClient,
    userClient: UserClient,
    private userService: UserService,
    applicationUserCrudClient: ApplicationUserCrudClient,
    indexService: IndexService,
    private $auth: AuthService,
    private sharedHeadsOfTermsService: SharedHeadsOfTermsService,
    private productClient: ProductClient,
    private dealLenderService: DealLenderService,
    oDataHelper: ODataHelper,
    protected $timeout: ng.ITimeoutService,
  ) {
    super(
      $routeParams,
      userClient,
      roleService,
      dealLenderMessageClient,
      applicationUserCrudClient,
      indexService,
      oDataHelper,
    );
    this.userClient.getCurrentUserAutofill().then((response) => {
      this.showAutofill = response;
    });

    if (this.$routeParams.openModule && this.$routeParams.openModule == "withdraw") {
      this.toggleWithdrawSection = true;
    } else if (this.$routeParams.openModule && this.$routeParams.openModule == "reject") {
      this.toggleRejectSection = true;
    } else if (this.$routeParams.openModule) {
      this.toggleFeedbackSection = true;
    }

    if (this.$routeParams.dealId && this.$routeParams.DealLenderId) {
      this.dataLoading = true;

      this.developmentFinanceDealClient
        .fetchCustom(this.$routeParams.dealId)
        .then((response) => {
          this.currentDeal = response;
          if (this.currentDeal) {
            this.dealLenderClient
              .fetchByDealId(
                this.$routeParams.dealId,
                this.roleService.getIsLenderVisible(),
                this.$routeParams.DealLenderId,
              )
              .then((response) => {
                this.dealLenders = response;
                if (this.$routeParams.DealLenderId) {
                  if (this.dealLenders.length != 1) {
                    this.noLenderOrMoreLenderError = true;
                    return;
                  }
                  this.currentCaseLender = this.dealLenders[0];

                  this.fileUpload =
                    this.currentDeal.attachments?.filter((f) => {
                      return f.dealLenderId == this.$routeParams.DealLenderId;
                    }) || [];
                  this.calculateGrossLoanValVal();
                  this.calculateBuildLoadCalcVal();
                  this.calculateLandLoanCalcVal();
                }
              })
              .finally(() => {
                this.populateLenderInformation(this.currentUser);

                // Scroll to the bottom of the page if we're expanding the message notification area
                if (this.toggleFeedbackSection) {
                  // the timeout delay of 100 is a bit of a hack and may not work well on slower networks
                  $timeout(function () {
                    window.scrollTo(0, document.body.scrollHeight);
                  }, 100);
                }
              });

            this.lenderTask = sessionStorage.getItem("lenderTask");
            if (this.lenderTask != null && this.lenderTask.length > 0) {
              switch (this.lenderTask) {
                case "reject":
                  this.showRejectSectionLender = true;
                  break;
                case "withdraw":
                  this.showWithdrawSectionLender = true;
                  break;
                case "feedback":
                  this.showFeedbackSectionLender = true;
                  this.updateCaseLenderMessageReadDatetime();
                  break;
                case "terms":
                  this.showHoTDetailSectionLender = true;
                  break;
                default:
                  break;
              }
            }
            this.productTypeText = ProductHelper.getProductTypeFullName(this.currentDeal.productType);
          } else {
            if ((this.$rootScope as any).selectedUser) {
              this.$location.path("/dashboard");
            }
          }
        })
        .finally(() => {
          this.dataLoading = false;
          this.getCurrentUserAndRoles();
        });
    }

    this.InterestRateTypeOptions = this.selectListService.GetInterestRateType();
  }

  /*checkingIfUserIsLender() {
            this.roleService.isLenderUser().then(response => {
                this.isLender = response;
            });
        }

        checkingIfUerIsBroker() {
            this.dataLoading = true;
            this.roleService.isBroker().then((response) => {
                this.isBroker = response;
            }).finally(() => {
                this.dataLoading = false;
            });
        }

        checkingIfUserIsAdmin() {
            this.dataLoading = true;
            this.roleService.isAdminUser().then((response) => {
                this.isAdmin = response;
            }).finally(() => {
                this.dataLoading = false;
            });
        }

        checkingIfUserIsClient() {
            this.dataLoading = true;
            this.roleService.isClientUser().then((response) => {
                this.isClient = response;
            }).finally(() => {
                this.dataLoading = false;
            });
        }*/

  /** Redirects to the case dashboard */
  goToCaseDashboard() {
    this.showFeedbackSectionLender = false;
    this.showHoTDetailSectionLender = false;
    this.showRejectSectionLender = false;
    this.showWithdrawSectionLender = false;
    if (
      this.isBroker &&
      this.currentCaseLender &&
      !this.currentCaseLender.isLenderReviewComplete &&
      (this.currentCaseLender.status == CaseLenderStateEnum.Offered ||
        this.currentCaseLender.status == CaseLenderStateEnum.Rejected ||
        this.currentCaseLender.status == CaseLenderStateEnum.Withdrawn)
    ) {
      this.prevPath = "devfinancecasedashboard";
      this.feedBackDTO.isLenderFeedback = true;
      this.showLenderFeedBackModal = true;
    } else {
      this.$location.path("/devfinancecasedashboard/" + this.currentDeal.id);
    }
  }

  /** Close modal after send feedback */
  closeModal() {
    this.showDirection = false;
    this.showTsAndCsModal = false;
    this.showInformationMessage = false;
    this.isConfirmClicked = false;
    this.showdeleteChatMessageModal = false;
    if (this.goToUserDashboard) {
      this.$auth.clearSelectedNavMenuAndFilterStorageData();
      this.$location.path("/userdashboard");
      this.goToUserDashboard = false;
      this.showFeedbackSectionLender = false;
      this.showHoTDetailSectionLender = false;
      this.showRejectSectionLender = false;
      this.showWithdrawSectionLender = false;
    }

    if (this.prevPath) {
      if (this.isLender) {
        this.$auth.clearSelectedNavMenuAndFilterStorageData();
        this.$location.path("/userdashboard");
      } else {
        this.$location.path(`/${this.prevPath}/${this.currentDeal.id}`);
      }
    }
  }

  goToLending() {
    if (
      this.isBroker &&
      this.currentCaseLender &&
      !this.currentCaseLender.isLenderReviewComplete &&
      (this.currentCaseLender.status == CaseLenderStateEnum.Offered ||
        this.currentCaseLender.status == CaseLenderStateEnum.Rejected ||
        this.currentCaseLender.status == CaseLenderStateEnum.Withdrawn)
    ) {
      this.prevPath = "dealforum";
      this.feedBackDTO.isLenderFeedback = true;
      this.showLenderFeedBackModal = true;
    } else {
      this.$location.path("/dealforum/" + this.currentDeal.id);
    }
  }

  saveUpdatedCaseLender(): void {
    this.dealLenderClient.addUpdate(this.currentCaseLender).then((response) => {
      this.currentCaseLender = response;
      this.messageContent = "Your changes have been saved.";
      this.showInformationMessage = true;
    });
  }

  dummyDIP() {
    this.dealLenderService.dummyDIP(this);
  }

  /** Process the Reject button being clicked*/
  rejectClicked(): void {
    this.isRejectClicked = true;
    this.dealLenderClient
      .rejectCase(this.currentCaseLender)
      .then((response) => {
        this.currentCaseLender.status = response.caseLenderState;
        this.brokerName = response.dealBrokerName;
        this.brokerOrganisationName = response.dealBrokerOrganisationName;
        this.messageContent = "The borrower has been notified you have rejected their application.";
      })
      .catch((error) => {
        this.messageContent = "Sorry, something went wrong. Please try again.";
        this.isRejectClicked = false;
      })
      .finally(() => {
        this.goToUserDashboard = true;
        this.currentCaseLender.isBrokerReviewComplete || this.currentDeal.brokerOrganisationId == null || !this.isLender
          ? (this.showInformationMessage = true)
          : this.showBrokerFeedBack();
      });
  }

  ///**Process the Withdraw button being clicked */
  withdrawClicked(): void {
    this.isWithdrawClicked = true;
    this.dealLenderClient
      .withdrawHoT(this.currentCaseLender)
      .then((response) => {
        this.currentCaseLender.status = response.caseLenderState;
        this.brokerName = response.dealBrokerName;
        this.brokerOrganisationName = response.dealBrokerOrganisationName;
        this.messageContent = "The borrower has been notified you have withdrawn terms for their application.";
      })
      .catch((error) => {
        this.messageContent = "Sorry, something went wrong. Please try again.";
        this.isWithdrawClicked = false;
      })
      .finally(() => {
        this.goToUserDashboard = true;
        this.currentCaseLender.isBrokerReviewComplete || this.currentDeal.brokerOrganisationId == null || !this.isLender
          ? (this.showInformationMessage = true)
          : this.showBrokerFeedBack();
      });
  }

  ///**Process the Submit button being clicked */
  submitClicked() {
    this.isConfirmClicked = true;
    this.showTsAndCsModal = true;
  }

  ///**Heads of Terms Submit button clicked event */
  submitHoTClicked() {
    // Close the Heads of Terms' Terms and Conditions modal
    this.showTsAndCsModal = false;
    this.sendingMessage = true;

    var request = {
      dealLender: this.currentCaseLender,
      dealLenderStatus: this.currentCaseLender.status,
    } as BridgingSubmitOfferRequest;

    // Submit the Heads of Terms
    this.dealLenderClient
      .submitOffer(request)
      .then((response) => {
        this.currentCaseLender.status = response.dealLenderStatus;
        this.brokerName = response.dealBrokerName;
        this.brokerOrganisationName = response.dealBrokerOrganisationName;
        this.messageContent = "Thank you for submitting a Decision in Principle.";
        this.goToUserDashboard = true;
      })
      .catch((error) => {
        this.messageContent =
          "Sorry, something went wrong while submitting your Decision in Principle. Please try again.";
        this.isConfirmClicked = false;
      })
      .finally(() => {
        this.currentCaseLender.isBrokerReviewComplete || this.currentDeal.brokerOrganisationId == null || !this.isLender
          ? (this.showInformationMessage = true)
          : this.showBrokerFeedBack();
        this.sendingMessage = false;
      });
  }

  /**
   * Process the Send Feedback button being clicked
   * @param message
   */
  sendChatMessage() {
    this.dataLoading = true;
    let DealChatMessage = {
      message: this.newChatMessage,
      dealId: this.$routeParams.dealId,
      deal: null,
      dealLenderId: this.$routeParams.DealLenderId,
      dealLender: null,
      senderUser: null,
      senderUserId: this.currentUser.id,
      senderRole: this.getSenderMessageRole(),
      recipientRoles: this.isLender ? MessageRoleEnum.Client | MessageRoleEnum.Broker : MessageRoleEnum.Lender,
    } as DealLenderMessage;

    this.dealLenderMessageClient
      .addUpdateCustom(DealChatMessage)
      .then((dealChatMessageResponse) => {
        this.currentCaseLender.dealLenderMessage.push(dealChatMessageResponse);
        this.newChatMessage = null;
      })
      .catch((error) => {
        this.messageContent = "Sorry, something went wrong while sending feedback. Please try again.";
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  showFullChatMessage(index) {
    this.showFullMessageId = index;
  }

  onFileSelect(files: FileAttachment[], module: ModuleEnum) {
    if (files.length > 0) {
      this.dealFileAttachmentService
        .UploadFileListInSync(
          files,
          this.uploadingFiles,
          this.$routeParams.dealId,
          this.fileUpload,
          module,
          this.$routeParams.DealLenderId,
        )
        .then((result) => {
          this.openModal = false;
        });
    }
  }

  downloadFile(file: DealFileAttachment) {
    this.dataLoading = true;
    this.dealFileAttachmentClient
      .getAmazonFileAccessUri(file.fileLocation)
      .then((uri) => {
        this.$window.open(uri);
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  deleteFile(file: DealFileAttachment) {
    this.fileUpload.splice(this.fileUpload.indexOf(file), 1);
    this.dealFileAttachmentClient.markAsDeleted(file.id).then((result) => {}); //remove on the server
  }

  disableDip() {
    return !this.showActionButtons();
  }

  showActionButtons() {
    if (
      this.currentCaseLender &&
      (this.currentCaseLender.status == CaseLenderStateEnum.Received ||
        this.currentCaseLender.status == CaseLenderStateEnum.Rejected ||
        this.currentCaseLender.status == CaseLenderStateEnum.Offered ||
        this.currentCaseLender.status == CaseLenderStateEnum.Cancelled ||
        this.currentCaseLender.status == CaseLenderStateEnum.Withdrawn)
    ) {
      return true;
    } else {
      return false;
    }
  }

  addClass(star: number, id: string) {
    this.feedBackService.addClass(star, id);
  }

  removeClass(star: number, id: string, rating) {
    this.feedBackService.removeClass(star, id, rating);
  }

  isFeedBackFormDisabled() {
    return this.feedBackService.isFeedBackFormDisabled(this.isLender, this.feedBackDTO);
  }

  updateRating(star, rating) {
    this.feedBackDTO = this.feedBackService.updateRating(star, rating, this.feedBackDTO);
  }

  submitFeedBack() {
    if (this.isLender) {
      this.feedBackDTO.organisationId = this.currentDeal.brokerOrganisationId;
      this.feedBackDTO.brokerUserId = this.currentDeal.brokerUserId;
      this.feedBackDTO.organisation = null;
      this.feedBackDTO.brokerUser = null;
      this.feedBackDTO.reviewerUserId = 0;
      this.feedBackDTO.reviewerUser = null;
    } else {
      this.feedBackDTO.lenderId = this.currentCaseLender.lenderId;
      this.feedBackDTO.lender = null;
      this.feedBackDTO.reviewerUserId = 0;
      this.feedBackDTO.reviewerUser = null;
    }

    this.feedBackClient.addFeedBack(this.currentCaseLender.id, true, this.feedBackDTO).then((response) => {
      if (this.isLender) {
        this.$auth.clearSelectedNavMenuAndFilterStorageData();
        this.$location.path("/userdashboard");
      } else {
        this.$location.path(`/${this.prevPath}/${this.currentDeal.id}`);
      }
    });
  }

  showBrokerFeedBack() {
    this.feedBackDTO.isBrokerFeedback = true;
    this.showBrokerFeedBackModal = true;
  }

  onClickDeleteMessageButton(message: DealLenderMessage) {
    this.showdeleteChatMessageModal = true;
    this.messageContent = "Are you sure you want to delete a selected message?";
    this.selectedDealLenderMessageDto = message;
    this.showConfirmDeleteButton = true;
  }

  deleteChatMessage() {
    this.dataLoading = true;
    this.dealLenderMessageClient
      .markAsDeleted(this.selectedDealLenderMessageDto.id)
      .then((response) => {
        this.currentCaseLender.dealLenderMessage = this.currentCaseLender.dealLenderMessage.filter(
          (x) => x.id != this.selectedDealLenderMessageDto.id,
        );
      })
      .catch((error) => {
        this.messageContent = "Sorry, something went wrong while deleting message. Please try again.";
      })
      .finally(() => {
        this.showdeleteChatMessageModal = false;
        delete this.selectedDealLenderMessageDto;
        this.showConfirmDeleteButton = false;
        this.dataLoading = false;
      });
  }

  /**Calculate the Total Net Loan */
  calculateTotalNetLoan() {
    var totalNetLoan: number = 0;
    if (this.currentCaseLender && this.currentCaseLender.buildLoan && this.currentCaseLender.landLoan) {
      totalNetLoan = +this.currentCaseLender.buildLoan + +this.currentCaseLender.landLoan;
      totalNetLoan = Math.round(totalNetLoan * 100) / 100;
    }
    return totalNetLoan;
  }

  /**Calculate total lender costs */
  totalLenderCosts() {
    var lenderCosts: number = 0;

    if (this.currentCaseLender) {
      lenderCosts =
        +this.currentCaseLender.lenderArrangementFee +
        +this.currentCaseLender.lenderExitFee +
        +this.currentCaseLender.interestCoverAllocation;
    }
    return lenderCosts;
  }

  /**Calculate Arrangement Amount */
  recalculateArrangementAmount() {
    if (this.currentCaseLender && this.currentCaseLender.totalGrossLoan) {
      this.currentCaseLender.lenderArrangementFeePercent =
        (this.currentCaseLender.lenderArrangementFee * 100) / this.currentCaseLender.totalGrossLoan;
      this.currentCaseLender.lenderArrangementFeePercent = parseFloat(
        this.currentCaseLender.lenderArrangementFeePercent.toFixed(2),
      );

      this.totalLenderCosts();
    }
  }

  /**Calculate borrower equity
         (Puchase Price - land loan)
         */
  calculateBorrowerEquity(calcShareholderDeposit: boolean = true) {
    var borrowerEquity: number = 0;

    if (
      this.currentDeal &&
      this.currentDeal.purchasePrice &&
      this.currentCaseLender &&
      this.currentCaseLender.landLoan
    ) {
      borrowerEquity = this.currentDeal.purchasePrice - this.currentCaseLender.landLoan;
    }

    if (calcShareholderDeposit) {
      this.calculateMinShareholderDeposit();
    }
    return Number(borrowerEquity);
  }

  /**Calculate true cost */
  calculateTrueCost(): number {
    if (this.currentCaseLender) {
      var trueCost: number =
        +this.currentCaseLender.interestRate / 12 +
        (+this.currentCaseLender.lenderArrangementFeePercent + +this.currentCaseLender.lenderExitFeePercent) /
          +this.currentCaseLender.loanTerm;
      return trueCost;
    }
  }

  /**Re-calculate arrangement percent */
  recalculateArrangementPercent() {
    if (this.currentCaseLender && this.currentCaseLender.totalGrossLoan) {
      this.currentCaseLender.lenderArrangementFee =
        (this.currentCaseLender.totalGrossLoan * this.currentCaseLender.lenderArrangementFeePercent) / 100;
      this.currentCaseLender.lenderArrangementFee = Math.round(this.currentCaseLender.lenderArrangementFee * 100) / 100;
      this.totalLenderCosts();
    }
  }

  /**Recalculate Exit Amount */
  recalculateExitAmount() {
    const element = event.currentTarget as HTMLInputElement;
    const value = parseFloat(element.value);
    if (this.currentCaseLender && this.currentCaseLender.totalGrossLoan) {
      this.currentCaseLender.lenderExitFee = value;
      this.currentCaseLender.lenderExitFeePercent =
        (this.currentCaseLender.lenderExitFee * 100) / this.currentCaseLender.totalGrossLoan;
      this.currentCaseLender.lenderExitFeePercent = Math.round(this.currentCaseLender.lenderExitFeePercent * 100) / 100;
      this.totalLenderCosts();
    }
  }

  /**Recalculate Exit Percent */
  recalculateExitPercent() {
    if (
      this.currentCaseLender &&
      this.currentCaseLender.totalGrossLoan &&
      this.currentCaseLender.lenderExitFeePercent
    ) {
      this.currentCaseLender.lenderExitFee =
        (this.currentCaseLender.totalGrossLoan * this.currentCaseLender.lenderExitFeePercent) / 100;
      this.currentCaseLender.lenderExitFee = Math.round(this.currentCaseLender.lenderExitFee * 100) / 100;
      this.totalLenderCosts();
    }
  }

  calculatemonetaryLAFee() {
    if (
      this.currentCaseLender.lenderArrangementFeePercent != null &&
      this.currentCaseLender.lenderArrangementFeePercent > 0 &&
      this.currentCaseLender.totalGrossLoan != null &&
      this.currentCaseLender.totalGrossLoan > 0
    ) {
      this.currentCaseLender.lenderArrangementFee =
        Math.round(this.currentCaseLender.totalGrossLoan * this.currentCaseLender.lenderArrangementFeePercent * 100) /
        100;
    } else {
      this.currentCaseLender.lenderArrangementFee = 0;
    }
  }

  calculatemonetaryLAPercent() {
    if (
      this.currentCaseLender.lenderArrangementFee != null &&
      this.currentCaseLender.lenderArrangementFee > 0 &&
      this.currentCaseLender.totalGrossLoan != null &&
      this.currentCaseLender.totalGrossLoan > 0
    ) {
      this.currentCaseLender.lenderArrangementFeePercent =
        this.currentCaseLender.lenderArrangementFee / this.currentCaseLender.totalGrossLoan;

      this.currentCaseLender.lenderArrangementFeePercent = parseFloat(
        this.currentCaseLender.lenderArrangementFeePercent.toFixed(4),
      );
    } else {
      this.currentCaseLender.lenderArrangementFeePercent = 0;
    }
  }

  calculatemonetaryLEFee() {
    if (
      this.currentCaseLender.lenderExitFeePercent != null &&
      this.currentCaseLender.lenderExitFeePercent > 0 &&
      this.currentCaseLender.totalGrossLoan != null &&
      this.currentCaseLender.totalGrossLoan > 0
    ) {
      this.currentCaseLender.lenderExitFee =
        Math.round(this.currentCaseLender.totalGrossLoan * this.currentCaseLender.lenderExitFeePercent * 100) / 100;
    } else {
      this.currentCaseLender.lenderExitFee = 0;
    }
  }

  calculatemonetaryLEPercent() {
    if (
      this.currentCaseLender.lenderExitFee != null &&
      this.currentCaseLender.lenderExitFee > 0 &&
      this.currentCaseLender.totalGrossLoan != null &&
      this.currentCaseLender.totalGrossLoan > 0
    ) {
      this.currentCaseLender.lenderExitFeePercent =
        this.currentCaseLender.lenderExitFee / this.currentCaseLender.totalGrossLoan;
      this.currentCaseLender.lenderExitFeePercent = parseFloat(this.currentCaseLender.lenderExitFeePercent.toFixed(4));
    } else {
      this.currentCaseLender.lenderExitFeePercent = 0;
    }
  }

  CalcTotalBuild(): number {
    var res: number = this.CalcAdditionalBuild();
    if (this.currentDeal && this.currentDeal.buildCosts) {
      res += Number(this.currentDeal.buildCosts);
    }

    res += this.calcContingencyCost();
    return res;
  }

  CalcAdditionalBuild(): number {
    var res: number = 0;
    if (this.currentDeal.hasProfessionalCostsBreakdown) {
      if (this.currentDeal.planningCosts) {
        res += Number(this.currentDeal.planningCosts);
      }
      if (this.currentDeal.projectManagementCosts) {
        res += Number(this.currentDeal.projectManagementCosts);
      }
      if (this.currentDeal.clientQSCosts) {
        res += Number(this.currentDeal.clientQSCosts);
      }
      if (this.currentDeal.s106CILCosts) {
        res += Number(this.currentDeal.s106CILCosts);
      }
      if (this.currentDeal.mechanicalEngineeringCosts) {
        res += Number(this.currentDeal.mechanicalEngineeringCosts);
      }
      if (this.currentDeal.structuralEngineeringCosts) {
        res += Number(this.currentDeal.structuralEngineeringCosts);
      }
      if (this.currentDeal.partyWallCosts) {
        res += Number(this.currentDeal.partyWallCosts);
      }
      if (this.currentDeal.warrantyCosts) {
        res += Number(this.currentDeal.warrantyCosts);
      }
      if (this.currentDeal.landscapingCosts) {
        res += Number(this.currentDeal.landscapingCosts);
      }
      if (this.currentDeal.otherProfessionalCosts) {
        res += Number(this.currentDeal.otherProfessionalCosts);
      }
    } else {
      if (this.currentDeal.additionalOngoingCosts) {
        res += Number(this.currentDeal.additionalOngoingCosts);
      }
    }
    return res;
  }

  calcContingencyCost(): number {
    var res: number = 0;
    if (this.currentDeal.contingency && this.currentDeal.buildCosts) {
      res = this.currentDeal.contingency * this.currentDeal.buildCosts;
      return res;
    }
    return res;
  }

  calculateGrossLoanValVal() {
    if (
      this.currentCaseLender.totalGrossLoan != null &&
      this.currentCaseLender.totalGrossLoan >= 0 &&
      this.currentDeal.gdv != null &&
      this.currentDeal.gdv >= 0
    ) {
      this.grossLoanCalcVal = parseFloat(
        ((this.currentCaseLender.totalGrossLoan / this.currentDeal.gdv) * 100).toFixed(2),
      );
    }

    if (this.currentCaseLender.totalGrossLoan != null && this.currentCaseLender.totalGrossLoan > 0) {
      if (
        this.currentCaseLender.lenderArrangementFeePercent != null &&
        this.currentCaseLender.lenderArrangementFeePercent > 0
      ) {
        this.calculatemonetaryLAFee();
      } else {
        if (this.currentCaseLender.lenderArrangementFee != null && this.currentCaseLender.lenderArrangementFee > 0) {
          this.calculatemonetaryLAPercent();
        }
      }

      if (this.currentCaseLender.lenderExitFeePercent != null && this.currentCaseLender.lenderExitFeePercent > 0) {
        this.calculatemonetaryLEFee();
      } else {
        if (this.currentCaseLender.lenderExitFee != null && this.currentCaseLender.lenderExitFee > 0) {
          this.calculatemonetaryLEPercent();
        }
      }
    } else {
      this.currentCaseLender.lenderArrangementFeePercent = 0;
      this.currentCaseLender.lenderArrangementFee = 0;
      this.currentCaseLender.lenderExitFeePercent = 0;
      this.currentCaseLender.lenderExitFee = 0;
    }
  }

  calculateBuildLoadCalcVal() {
    if (this.currentCaseLender.buildLoan != null && this.currentCaseLender.buildLoan >= 0) {
      this.builLoanCalcVal = parseFloat(((this.currentCaseLender.buildLoan / this.CalcTotalBuild()) * 100).toFixed(2));
    }
  }

  calculateLandLoanCalcVal() {
    if (this.currentCaseLender.landLoan != null && this.currentCaseLender.landLoan >= 0) {
      this.landLoanCalcVal = parseFloat(
        ((this.currentCaseLender.landLoan / this.currentDeal.purchasePrice) * 100).toFixed(2),
      );
    }
  }

  getRateTypeText(e: InterestRateTypeEnum) {
    switch (e) {
      case InterestRateTypeEnum.Fixed:
        return "Fixed";
      case InterestRateTypeEnum.Variable:
        return "Variable";
      default:
        break;
    }
  }

  getSenderMessageRole() {
    if (this.isLender) {
      return MessageRoleEnum.Lender;
    } else if (this.isBroker) {
      return MessageRoleEnum.Broker;
    } else if (this.isAdmin) {
      return MessageRoleEnum.Admin;
    } else if (this.isClient) {
      return MessageRoleEnum.Client;
    }
  }

  calculateMinShareholderDeposit() {
    if (this.currentCaseLender) {
      if (
        this.currentCaseLender.minShareholderDepositPercent != null &&
        this.currentCaseLender.minShareholderDepositPercent > 0
      ) {
        this.currentCaseLender.minShareholderDeposit =
          Math.round(this.calculateBorrowerEquity(false) * this.currentCaseLender.minShareholderDepositPercent * 100) /
          100;
      } else {
        this.currentCaseLender.minShareholderDeposit = 0;
      }
    }
  }

  calculateMinShareholderDepositPercent() {
    if (this.currentCaseLender) {
      if (this.currentCaseLender.minShareholderDeposit != null && this.currentCaseLender.minShareholderDeposit > 0) {
        this.currentCaseLender.minShareholderDepositPercent = parseFloat(
          (this.currentCaseLender.minShareholderDeposit / this.calculateBorrowerEquity(false)).toFixed(4),
        );
      } else {
        this.currentCaseLender.minShareholderDepositPercent = 0;
      }
    }
  }

  isCurrentUserAllowedToSendChat() {
    if (this.currentUser && this.currentDeal && (this.toggleFeedbackSection || this.showFeedbackSectionLender)) {
      return this.sharedHeadsOfTermsService.isCurrentUserAllowedToSendChat(
        this.isBroker,
        this.currentDeal.status,
        this.currentDeal.isReferredToConnect,
        this.currentUser.isConnectUser,
      );
    }
    return false;
  }
}
